module.exports = function ($) {

  if ($.swViewportWidth === undefined) {
    $.swViewportWidth = function () {
      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    };
  }

  if ($.swViewportHeight === undefined) {
    $.swViewportHeight = function () {
      return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    };
  }

};
